import React, { useContext, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import {
  CloseButton,
  Card,
  Col,
  Row,
  Button,
  Nav,
  Form,
} from "react-bootstrap";

import Section from "../../common/Section";

import bgShape from "../../../assets/img/illustrations/bg-shape.png";
import shape1 from "../../../assets/img/illustrations/shape-1.png";
import halfCircle from "../../../assets/img/illustrations/half-circle.png";
import kiteLogin from "../../../assets/img/login-img/kite-logo.png";
import Alice from "../../../assets/img/login-img/alice.webp";
import AngelBooking from "../../../assets/img/login-img/angel_booking.webp";
import Fyers from "../../../assets/img/login-img/Logo-fyers-final.webp";
import IIFL from "../../../assets/img/login-img/IIFL.NS.webp";
import upstock from "../../../assets/img/login-img/upstock.webp";
import ICICI from "../../../assets/img/login-img/icic.webp";
import paisa from "../../../assets/img/login-img/5paisa.webp";
import jainam from "../../../assets/img/login-img/jainam.png";
import Dhanlog from "../../../assets/img/login-img/dhan.jpg";
import FlatTrade from "../../../assets/img/login-img/flattrade.jpg";
import shoonya from "../../../assets/img/login-img/shoonya-logo.png";
import xts from "../../../assets/img/login-img/xts.png";
import kotakNeo from "../../../assets/img/login-img/kotakneo.png";
import firstock from "../../../assets/img/login-img/firstock.png"
import zebu from "../../../assets/img/login-img/zebu.svg"
import groww from "../../../assets/img/login-img/groww-icon.png"
import arrow from "../../../assets/img/login-img/arrow.svg";

import BrokerLoginModal from "../../authentication/modal/brokerLogin";
import safeImg from "../../../assets/img/safe.png";

// import zerodhaImg2 from 'assets/img/zerodha-configration/zerodha-2.png';
import { logoutUser } from "../../../api/authentication";
import { removeUser } from "../../../redux/actions/user";
import { makeStyles } from "@material-ui/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { isMobile } from "react-device-detect";
import { Collapse, Modal } from "antd";
import logo from "../../../assets/img/favicons/android-chrome-512x512.png";
import AppContext from "../../../context/Context";
import {
  deleteCookieCredentials,
  getLocalStorageObject,
  setLocalStorageObject,
} from "../../../util/helper";
import BrokerService from "../../../services/broker.service";
// import jainamXTS from "../../../assets/img/login-img/jainam.webp";
import BrokerCard from "./BrokerCard";
import { useToast } from "components/common/custom-toast/Toast";

const { Panel } = Collapse;

const useStyles = makeStyles(() => ({
  logout: {
    position: "absolute",
    right: "8px",
    top: "3px",
    cursor: "pointer",
  },
  bottomText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    margin: "auto",
    borderRadius: "8px",
    cursor: "pointer",
  },
  h5: {
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
  },
  p: {
    fontSize: "15px",
    margin: "0",
    cursor: "pointer",
  },
  textDiv: {
    marginLeft: "15px",
    cursor: "pointer",
    marginRight: "15px",
    textAlign: "left",
  },
  collepsDiv: {
    width: "90%",
    margin: "auto",
  },
  backButton: {
    cursor: "pointer",
    marginTop: "13px",
    marginBottom: "13px",
  },
  boxSize: {
    width: "90%",
    height: "68px",
    color: "",
    fontWeight: "600",
    fontSize: "14px",
    padding: "6px",
  },
  h5Bold: {
    fontWeight: "600",
    color: "#2c87f2",
    fontSize: "16px",
  },
  textHeading: {},
  btnSpace: {
    marginBottom: "0",
  },
}));

const BrokerLogin = (props) => {
  const {
    config: { isDark, isNavbarVerticalCollapsed },
    setConfig,
  } = useContext(AppContext);

  const [show, setShow] = useState(false);
  const [defaultActiveKey, setdefaultActiveKey] = useState(1);
  const [isSafe, setSafe] = useState(false);
  const [domain, setdomain] = useState();
  const inputRef = useRef(null);

  const [loginType, setloginType] = useState(false);
  const [loginTypeSubType, setloginTypeSubType] = useState();
  const [faqOpen, setFaqOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useToast()

  useEffect(() => {

    let subDomain = window.location.host.split(".")[0];
    if (subDomain == "www") {
      subDomain = window.location.host.split(".")[1];
    }
    setdomain(subDomain);
  }, []);

  const showLoginModal = (type, subtype) => {
    if (type == 12) {

      var brokerAddParma = {
        "name": 'Paper Trading',
        "type": 'papertrading',
        "autoLogin": false,
        "loginType": "partner",
        "configuration": {
          "userName": user.userID,
          "apiKey": "",
          "secret": ""
        }
      };
      BrokerService.addBroker(brokerAddParma).then(
        response => {

          if (response.code == 500) {
            toast.error("Something went wrong. Please contact support!")
          } else if (response.code == 403) {
            navigate("/authentication/login");
          } else {
            if (response.error == "broker name already used") {
              return
            } else {
              BrokerService.getBrokers().then(
                brokersRes => {
                  if (brokersRes.code === 200) {
                    props.onBrokerChanged();
                    if (brokersRes.data.brokers) {
                      var filterUsername = brokersRes.data.brokers.filter((item) => item.type == response.data.type);
                    }

                  } else {
                    toast.error('session expired');
                  }
                },
                error => {

                }
              );
            }
          }
        })
    } else {
      setShow(true);
      setloginType(type)
    }
    if (type == 11 || type == 13) {
      setloginTypeSubType(subtype)
    }
  };
  const classes = useStyles();

  async function logout() {
    const res = await logoutUser(user);
    const { code } = res;
    deleteCookieCredentials();
    dispatch(removeUser());
    navigate("/authentication/login");
  }
  const onTabChange = (key) => {
    setdefaultActiveKey(key);
  };
  const OpenIsSafe = (isSafe) => {
    setSafe(!isSafe);
  };
  const closePopup = () => {
    if (getLocalStorageObject("current-page")?.pathname) {
      navigate(getLocalStorageObject("current-page")?.pathname);
    } else {
      navigate("/broker-login");
    }
  };
  if (props?.autoShow) {
    return (
      <div style={{ backgroundColor: isDark ? "inherit" : "#fff" }}>
        {!isSafe && (
          <>
            <div className={!isMobile ? "landing-page-header_" : ""} style={{ textAlign: "left", backgroundColor: isDark ? "inherit" : "#fff", paddingTop: "0px", paddingBottom: "6px" }}>
              <h6 className={classes.h5Bold} style={{ margin: 0, color: isDark ? "#cbd5e1" : "#4b5563" }}>Preferred brokers</h6>
              <div style={{ height: 1, background: isDark ? "#2a2f36" : "#eaeaea", marginTop: 8 }} />
            </div>
            <Row className="g-1 mb-1 broker-list-l">
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={paisa} name="5Paisa" status="Analysis only" onClick={() => showLoginModal(5)} title="Login with 5Paisa" aria-label="Login with 5Paisa" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={firstock} name="Firstock" status="Analysis only" onClick={() => showLoginModal(15)} title="Login with Firstock" aria-label="Login with Firstock" />
              </Col>
            </Row>
            <div className={!isMobile ? "landing-page-header_" : ""} style={{ textAlign: "left", backgroundColor: isDark ? "inherit" : "#fff", paddingTop: "12px", paddingBottom: "6px" }}>
              <h6 className={classes.h5Bold} style={{ margin: 0, color: isDark ? "#cbd5e1" : "#4b5563" }}>Other brokers</h6>
              <div style={{ height: 1, background: isDark ? "#2a2f36" : "#eaeaea", marginTop: 8 }} />
            </div>
            <Row className="g-1 mb-1 broker-list-l">
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={logo} name="Paper Trading" status="Demo" subtitle="No real orders" onClick={() => showLoginModal(12)} title="Open Paper Trading (Demo)" aria-label="Open Paper Trading Demo" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={Alice} name="Aliceblue" status="Analysis only" onClick={() => showLoginModal(1)} title="Login with Aliceblue" aria-label="Login with Aliceblue" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={AngelBooking} name="Angel One" status="Analysis only" onClick={() => showLoginModal(4)} title="Login with Angel One" aria-label="Login with Angel One" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={kiteLogin} name="Zerodha" status="Trading enabled" onClick={() => showLoginModal(0)} title="Login with Zerodha" aria-label="Login with Zerodha" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={Fyers} name="Fyers" status="Analysis only" onClick={() => showLoginModal(2)} title="Login with Fyers" aria-label="Login with Fyers" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={Dhanlog} name="Dhan" status="Analysis only" onClick={() => showLoginModal(8)} title="Login with Dhan" aria-label="Login with Dhan" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={upstock} name="Upstox" status="Analysis only" onClick={() => showLoginModal(7)} title="Login with Upstox" aria-label="Login with Upstox" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={kotakNeo} name="Kotak Neo" status="Analysis only" onClick={() => showLoginModal(14)} title="Login with Kotak Neo" aria-label="Login with Kotak Neo" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={shoonya} name="Shoonya" status="Analysis only" onClick={() => showLoginModal(10)} title="Login with Shoonya" aria-label="Login with Shoonya" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={FlatTrade} name="FlatTrade" status="Analysis only" onClick={() => showLoginModal(9)} title="Login with FlatTrade" aria-label="Login with FlatTrade" />
              </Col>
              {/* <Col md={4} xs={6} className={classes.btnSpace}>
              <BrokerCard logoSrc={jainamXTS} name="Jainam (XTS)" status="Trading enabled" onClick={() => showLoginModal(13,'jainam')} title="Login with Jainam XTS" aria-label="Login with Jainam XTS" />
            </Col> */}
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={zebu} name="Zebu" status="Analysis only" onClick={() => showLoginModal(16)} title="Login with Zebu" aria-label="Login with Zebu" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={xts} name="Open XTS" status="200+ brokers" infoTooltip="200+ brokers supported" onClick={() => showLoginModal(11, "acagarwal")} title="Open XTS (supports 200+ brokers)" aria-label="Open XTS supports 200+ brokers" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={groww} name="Groww" status="Analysis only" onClick={() => showLoginModal(18)} title="Login with Groww" aria-label="Login with Groww" />
              </Col>
              <Col md={4} xs={6} className={classes.btnSpace}>
                <BrokerCard logoSrc={arrow} name="Arrow" status="Analysis only" onClick={() => showLoginModal(17)} title="Login with Arrow" aria-label="Login with Arrow" />
              </Col>
              {/* <Col md={4} xs={6} className={classes.btnSpace}>
              <BrokerCard logoSrc={jainam} name="Jainam Duck" status="Analysis only" onClick={() => showLoginModal(6)} title="Login with Jainam Duck" aria-label="Login with Jainam Duck" />
            </Col>
            <Col md={4} xs={6} className={classes.btnSpace}>
              <BrokerCard logoSrc={ICICI} name="ICICI Direct" status="Analysis only" onClick={() => showLoginModal(3)} title="Login with ICICI Direct" aria-label="Login with ICICI Direct" />
            </Col> */}
            </Row>
          </>
        )}
        {isSafe && (
          <Row className="g-0 m-auto w-90">
            <Col md={12} xs={12} className="mb-3">
              <div className={classes.collepsDiv}>
                <div className={classes.backButton} onClick={() => OpenIsSafe(isSafe)}>
                  <FontAwesomeIcon icon={"arrow-left"} /> Back
                </div>
                <Collapse accordion defaultActiveKey={[defaultActiveKey]} onChange={onTabChange} activeKey={defaultActiveKey}>
                  <Panel header="Does FNOTrader get access to my broker account password?" key="1">
                    <ul>
                      <li>No, we do not get access to the password for your broker account.</li>
                      <li>At time of login, we redirect you to broker's site. Your password is entered only there.</li>
                    </ul>
                  </Panel>
                  <Panel header="Will I be charged anything if I login with my broker?" key="2">
                    <ul>
                      <li>No, we will not charge you anything for logging in with broker.</li>
                      <li>We don't make any automatic/hidden charges/deductions.</li>
                      <li>You will be charged ONLY if you explicitly choose to buy a plan.</li>
                    </ul>
                  </Panel>
                  <Panel header="Why trust FNOTrader?" key="3">
                    <ul>
                      <li>Your broker is on the login because we have legally partnered with them, and cleared their security tests.</li>
                      <li>We do not monetize you through third parties or distribute your personal information or trading data to any third parties in any form whatsoever.</li>
                      <li>We do not store any of your trading data in any manner.</li>
                    </ul>
                  </Panel>
                  <Panel header="Do you place any orders from my account?" key="4">
                    <ul>
                      <li>We will place, modify, or cancel orders only when you do it manually by clicking on Buy or Sell button.</li>
                      <li>No order will be placed, modified, or cancelled automatically or otherwise by the app or anyone else without your explicit authorization.</li>
                    </ul>
                  </Panel>
                </Collapse>
              </div>
            </Col>
          </Row>
        )}
        <Row className="g-0 mb-3 mt-3">
          <Col md={12} xs={12} className="mb-2 mt-2 text-center">
            <Link to="/broker-login?view=new">
              <h5 className={classes.h5}>Don’t have a broker account?</h5>
              <h5 className={classes.h5Bold}>Click here to open one today!</h5>
            </Link>
          </Col>
        </Row>
        <BrokerLoginModal
          loginTypeSubType={loginTypeSubType}
          inputRef={inputRef}
          loginType={loginType}
          show={show}
          close={() => setShow(false)}
          onChanged={props?.onBrokerChanged}
        />
      </div>
    );
  }

  return (
    <Section fluid className="py-0">
      <Row className="g-0 min-vh-100 flex-center">
        <Col lg={4} xxl={5} className="py-3 position-relative">
          <img
            className="bg-auth-circle-shape"
            src={bgShape}
            alt=""
            width="250"
          />
          <img
            className="bg-auth-circle-shape-2"
            src={shape1}
            alt=""
            width="150"
          />
          <Card className="overflow-hidden fixed-width-page z-index-1">
            <Card.Body className="p-0">
              <Row className="g-0 fixed-height-page">
                <Col md={12}>
                  {!isSafe && (
                    <div>
                      <div className={classes.logout}>
                        {/* <Tooltip title="Logout">
                          <img
                            className=""
                            src={logoutImg}
                            alt=""
                            width="30"
                            title="Logout"
                            onClick={()=>logout()}
                          />
                        </Tooltip> */}
                        <Tooltip title="Close">
                          <CloseButton
                            className="btn btn-circle btn-sm transition-base p-0"
                            onClick={() => closePopup()}
                          />
                        </Tooltip>
                      </div>
                      <div
                        style={{ marginBottom: "0px", marginTop: "10px" }}
                        className="d-flex justify-content-center align-items-center d-block d-xs-none"
                      >
                        <img
                          className="text-center"
                          src={logo}
                          alt=""
                          width={40}
                          style={{ marginRight: "5px" }}
                        />
                        <h5
                          className="text-center "
                          style={{
                            color: "#2c87f2",
                            fontWeight: "800",
                            fontSize: "26px",
                          }}
                        >
                          FNOTrader
                        </h5>
                      </div>
                      {/* <NavItemPill step={1}></NavItemPill> */}
                      <div
                        className={!isMobile ? "landing-page-header_" : ""}
                        style={{
                          textAlign: "center",
                          color: "#2c87f2",
                          backgroundColor: isDark ? "inherit" : "#fff",
                          paddingTop: "15px",
                          paddingBottom: "15px",
                        }}
                      >
                        <h4 className={classes.h5Bold}>
                          {" "}
                          Log in with your broker account
                        </h4>
                      </div>
                      {domain === "5paisa" ? (
                        <Row className="g-0 ps-3 mb-1 broker-list-l">
                          <Col md={4} xs={6} className={classes.btnSpace}>
                            <Button
                              variant="outline-secondary"
                              size="md"
                              className={classes.boxSize}
                              onClick={() => showLoginModal(5)}
                            >
                              <img className="" src={paisa} alt="" width="30" />
                              <p className={classes.textHeading}>5Paisa </p>
                            </Button>
                          </Col>
                        </Row>
                      ) : (
                        <>
                          <div className={!isMobile ? "landing-page-header_" : ""} style={{ textAlign: "left", backgroundColor: isDark ? "inherit" : "#fff", paddingTop: "0px", paddingBottom: "6px" }}>
                            <h6 className={classes.h5Bold} style={{ margin: 0, color: isDark ? "#cbd5e1" : "#4b5563" }}>Preferred brokers</h6>
                            <div style={{ height: 1, background: isDark ? "#2a2f36" : "#eaeaea", marginTop: 8 }} />
                          </div>
                          <Row className="g-0 ps-3 mb-1 broker-list-l">
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={paisa}
                                name="5Paisa"
                                status="Analysis only"
                                onClick={() => showLoginModal(5)}
                                title="Login with 5Paisa"
                                aria-label="Login with 5Paisa"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={firstock}
                                name="Firstock"
                                status="Analysis only"
                                onClick={() => showLoginModal(15)}
                                title="Login with Firstock"
                                aria-label="Login with Firstock"
                              />
                            </Col>
                          </Row>
                          <div className={!isMobile ? "landing-page-header_" : ""} style={{ textAlign: "left", backgroundColor: isDark ? "inherit" : "#fff", paddingTop: "12px", paddingBottom: "6px" }}>
                            <h6 className={classes.h5Bold} style={{ margin: 0, color: isDark ? "#cbd5e1" : "#4b5563" }}>Other brokers</h6>
                            <div style={{ height: 1, background: isDark ? "#2a2f36" : "#eaeaea", marginTop: 8 }} />
                          </div>
                          <Row className="g-0 ps-3 mb-1 broker-list-l">
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={logo}
                                name="Paper Trading"
                                status="Demo"
                                subtitle="No real orders"
                                onClick={() => showLoginModal(12)}
                                title="Open Paper Trading (Demo)"
                                aria-label="Open Paper Trading Demo"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={Alice}
                                name="Aliceblue"
                                status="Analysis only"
                                onClick={() => showLoginModal(1)}
                                title="Login with Aliceblue"
                                aria-label="Login with Aliceblue"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={AngelBooking}
                                name="Angel One"
                                status="Analysis only"
                                onClick={() => showLoginModal(4)}
                                title="Login with Angel One"
                                aria-label="Login with Angel One"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={kiteLogin}
                                name="Zerodha"
                                status="Trading enabled"
                                onClick={() => showLoginModal(0)}
                                title="Login with Zerodha"
                                aria-label="Login with Zerodha"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={Fyers}
                                name="Fyers"
                                status="Analysis only"
                                onClick={() => showLoginModal(2)}
                                title="Login with Fyers"
                                aria-label="Login with Fyers"
                              />
                            </Col>

                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={Dhanlog}
                                name="Dhan"
                                status="Analysis only"
                                onClick={() => showLoginModal(8)}
                                title="Login with Dhan"
                                aria-label="Login with Dhan"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={upstock}
                                name="Upstox"
                                status="Analysis only"
                                onClick={() => showLoginModal(7)}
                                title="Login with Upstox"
                                aria-label="Login with Upstox"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={kotakNeo}
                                name="Kotak Neo"
                                status="Analysis only"
                                onClick={() => showLoginModal(14)}
                                title="Login with Kotak Neo"
                                aria-label="Login with Kotak Neo"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={shoonya}
                                name="Shoonya"
                                status="Analysis only"
                                onClick={() => showLoginModal(10)}
                                title="Login with Shoonya"
                                aria-label="Login with Shoonya"
                              />
                            </Col>

                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={FlatTrade}
                                name="FlatTrade"
                                status="Analysis only"
                                onClick={() => showLoginModal(9)}
                                title="Login with FlatTrade"
                                aria-label="Login with FlatTrade"
                              />
                            </Col>

                            {/* <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={jainamXTS}
                                name="Jainam (XTS)"
                                status="Trading enabled"
                                onClick={() => showLoginModal(13, "jainam")}
                                title="Login with Jainam XTS"
                                aria-label="Login with Jainam XTS"
                              />
                            </Col> */}

                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={zebu}
                                name="Zebu"
                                status="Analysis only"
                                onClick={() => showLoginModal(16)}
                                title="Login with Zebu"
                                aria-label="Login with Zebu"
                              />
                            </Col>

                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={xts}
                                name="Open XTS"
                                status="200+ brokers"
                                infoTooltip="200+ brokers supported"
                                onClick={() => showLoginModal(11, "acagarwal")}
                                title="Open XTS (supports 200+ brokers)"
                                aria-label="Open XTS supports 200+ brokers"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={groww}
                                name="Groww"
                                status="Analysis only"
                                onClick={() => showLoginModal(18)}
                                title="Login with Groww"
                                aria-label="Login with Groww"
                              />
                            </Col>
                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={logo}
                                name="Arrow"
                                status="Analysis only"
                                onClick={() => showLoginModal(17)}
                                title="Login with Arrow"
                                aria-label="Login with Arrow"
                              />
                            </Col>

                            {/* <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={jainam}
                                name="Jainam Duck"
                                status="Analysis only"
                                onClick={() => showLoginModal(6)}
                                title="Login with Jainam Duck"
                                aria-label="Login with Jainam Duck"
                              />
                            </Col>

                            <Col md={4} xs={6} className={classes.btnSpace}>
                              <BrokerCard
                                logoSrc={ICICI}
                                name="ICICI Direct"
                                status="Analysis only"
                                onClick={() => showLoginModal(3)}
                                title="Login with ICICI Direct"
                                aria-label="Login with ICICI Direct"
                              />
                            </Col> */}
                          </Row>
                        </>
                      )}

                      {/* <Row className="g-0 ">
                      <Col md={12} xs={12} className="text-center"  >
                        <Link to={getLocalStorageObject('current-page')?.pathname} > 
                          <Button  > 
                                  <p className={classes.p}>Skip Broker Login</p>
                          </Button> 
                        </Link> 
                      </Col>
                     </Row>          */}
                      <Row className="g-0 mb-3">
                        <Col md={12} xs={12} className="mb-3 text-center">
                          <Link to="/broker-login?view=new">
                            <h5 className={classes.h5}>
                              Don’t have a broker account?
                            </h5>
                            <h5 className={classes.h5Bold}>
                              Click here to open one today!
                            </h5>
                          </Link>
                        </Col>
                      </Row>
                    </div>
                  )}
                  {isSafe && (
                    <>
                      <div
                        style={{ marginBottom: "20px", marginTop: "15px" }}
                        className="d-flex justify-content-center align-items-center d-block d-xs-none"
                      >
                        <img
                          className="text-center"
                          src={logo}
                          alt=""
                          width={40}
                          style={{ marginRight: "5px" }}
                        />
                        <h5
                          className="text-center "
                          style={{
                            color: "#2c87f2",
                            fontWeight: "800",
                            fontSize: "26px",
                          }}
                        >
                          FNOTrader
                        </h5>
                      </div>
                      <Row className="g-0 m-auto w-90">
                        <Col md={12} xs={12} className="mb-3">
                          <div className={classes.collepsDiv}>
                            <div
                              className={classes.backButton}
                              onClick={() => OpenIsSafe(isSafe)}
                            >
                              {" "}
                              <FontAwesomeIcon icon={"arrow-left"} /> Back
                            </div>
                            <Collapse
                              accordion
                              defaultActiveKey={[defaultActiveKey]}
                              onChange={onTabChange}
                              activeKey={defaultActiveKey}
                            >
                              <Panel
                                header="Does FNOTrader get access to my broker account password?"
                                key="1"
                              >
                                <ul>
                                  <li>
                                    No, we do not get access to the password for
                                    your broker account.
                                  </li>
                                  <li>
                                    At time of login, we redirect you to
                                    broker's site. Your password is entered only
                                    there.
                                  </li>
                                </ul>
                              </Panel>
                              <Panel
                                header="Will I be charged anything if I login with my broker?"
                                key="2"
                              >
                                <ul>
                                  <li>
                                    No, we will not charge you anything for
                                    logging in with broker.
                                  </li>
                                  <li>
                                    We don't make any automatic/hidden
                                    charges/deductions.
                                  </li>
                                  <li>
                                    You will be charged ONLY if you explicitly
                                    choose to buy a plan.
                                  </li>
                                </ul>
                              </Panel>
                              <Panel header="Why trust FNOTrader?" key="3">
                                <ul>
                                  <li>
                                    Your broker is on the login because we have
                                    legally partnered with them, and cleared
                                    their security tests.
                                  </li>
                                  <li>
                                    We do not monetize you through third parties
                                    or distribute your personal information or
                                    trading data to any third parties in any
                                    form whatsoever.
                                  </li>
                                  <li>
                                    We do not store any of your trading data in
                                    any manner.
                                  </li>
                                </ul>
                              </Panel>
                              <Panel
                                header="Do you place any orders from my account?"
                                key="4"
                              >
                                <ul>
                                  <li>
                                    We will place, modify, or cancel orders only
                                    when you do it manually by clicking on Buy
                                    or Sell button.
                                  </li>
                                  <li>
                                    No order will be placed, modified, or
                                    cancelled automatically or otherwise by the
                                    app or anyone else without your explicit
                                    authorization.
                                  </li>
                                </ul>
                              </Panel>
                            </Collapse>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>
              </Row>
              <BrokerLoginModal
                loginTypeSubType={loginTypeSubType}
                inputRef={inputRef}
                loginType={loginType}
                show={show}
                close={() => setShow(false)}
              ></BrokerLoginModal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default BrokerLogin;